import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { AuthService, provideAuth0 } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { ACCESS_TOKEN, AGENT_CLIENT_CONFIG } from './chat/agent-client';
import { AUTH_SESSION, auth0Session, noSession } from './chat/auth-session';

// The test stage runs without Auth0; every other stage signs the user in and sends their
// access token for the Bannerflow Resource API to agent-bff.
const authProviders =
    environment.stage === 'test'
        ? [
              { provide: ACCESS_TOKEN, useValue: (): Promise<string> => Promise.resolve('') },
              { provide: AUTH_SESSION, useValue: noSession }
          ]
        : [
              provideAuth0({
                  domain: environment.LOGIN_URL,
                  clientId: environment.CLIENT_ID,
                  authorizationParams: {
                      redirect_uri: `${window.location.origin}/${window.location.search}`,
                      audience: 'https://bannerflow.com/resources/',
                      scope: 'openid profile email offline_access'
                  },
                  httpInterceptor: {
                      allowedList: environment.API_URLS.map(url => `${url}/*`)
                  },
                  useRefreshTokens: true
              }),
              {
                  provide: ACCESS_TOKEN,
                  useFactory:
                      (auth: AuthService): (() => Promise<string>) =>
                      () =>
                          firstValueFrom(auth.getAccessTokenSilently()),
                  deps: [AuthService]
              },
              { provide: AUTH_SESSION, useFactory: auth0Session }
          ];

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        ...authProviders,
        {
            provide: AGENT_CLIENT_CONFIG,
            useValue: { agentBffUrl: environment.AGENT_BFF_URL, agentName: environment.AGENT_NAME }
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync() // Needed for @bannerflow/ui
    ]
};
